var styles = {"root":"MonthList_root__3BNZC","scrolling":"MonthList_scrolling__2ZkEu"};

export default styles;
